<template>
  <c-view>
    <c-page>
      <c-navbar title="添加礼金券"></c-navbar>
      <c-content>
        <div>
          <div class="card-panel">
            <img src="../../../assets/images/coupon/card/card.png"
                 alt="">
            <div class=" text-color text-center gray">刮开卡片上的涂层，获取编码</div>
          </div>
          <div class="cell-items">
            <c-cell-input class="input-placeholder-gray"
                          title="编码"
                          v-model="formData.couponCode"
                          @input="inputChange"
                          input-placeholder="输入14位编码">
              <span v-if="showConfirmBtn"
                    class="text-color orange pl-10"
                    slot="foot"
                    @click="getCardInfo">确定</span>
            </c-cell-input>
            <template v-if="!showIndustry">
              <c-cell title="服务"
                      :desc="cardInfo.name"
                      :point="false">
              </c-cell>
            </template>
            <template v-else>
              <c-cell-select title="服务"
                             :point="true"
                             :c-select-label="true"
                             :is-disabled="disabledIndustry"
                             :options="IndustryList.options"
                             v-model="formData.industryId">
              </c-cell-select>
            </template>
          </div>
        </div>
        <c-button class="mt-30"
                  @click.native="bindSubmit"
                  :class="{'rightText-disabled': !cardInfo.isValid}">完成
        </c-button>
      </c-content>
    </c-page>
    <transition name="slide-right"
                mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
@import './index.scss';
</style>
<style lang="scss" scoped>
.rightText-disabled {
  opacity: 0.5;
}
</style>
<script>
import regs from '../../../tools/regs.js'
import BindItem from '../../../model/coupon/card-bind/index'
import IndustryList from '../../../model/coupon/card-bind/industry-entity'
import debounce from 'lodash.debounce'

export default {
  name: 'CardBind',
  data () {
    const bindItem = new BindItem()
    return {
      couponStatus: {
        couponHasBind: 0,
        couponActive: 2
      },
      IndustryList,
      bindItem,
      formData: bindItem.formData,
      userVersionObj: {},
      cardInfo: {},
      gotCardInfo: true // 显示确认的某一条件
    }
  },
  components: {},
  created () {
  },
  async mounted () {
    await this.getUserVersion()
  },
  beforeDestroy () {
  },
  methods: {
    // 关闭view
    setBackAction () {
      if (!window.$fe_bridge) return
      $fe_bridge.navigation.setBackAction('javascript:if(window.router.app.$route.path!=="/"&&location.search.length == 0){router.app.$router.back()}else{$fe_bridge.navigation.popViewController()}') // eslint-disable-line
    },
    bindCardValidate () {
      if (this.cardInfo.forAdvance && this.userVersionObj.canOnlyBindIndustryVersion) {
        // 提示用户不能使用该功能券
        this.$wejs.alert('行业版用户不支持绑定高级版！')
        return false
      }
      if (this.cardInfo.isCommonIndustryCoupon && !this.formData.industryId.value) {
        this.$wejs.alert('请选择行业')
        return false
      }
      return true
    },
    // 绑定优惠券
    bindCoupon () {
      this.bindItem.bindCard(this.formData.couponCode).then(data => {
        if (data.result) {
          this.activeCard()
        } else {
          this.$wejs.alert(data.message)
        }
      })
    },
    // 获取用户信息
    async getUserVersion () {
      this.userVersionObj = await this.bindItem.getUserVersion()
    },
    // 提交绑定
    async getCardInfo () {
      if (!this.formData.couponCode) {
        this.$wejs.alert(regs.cardNumber.nil)
        return false
      }
      if (!regs.cardNumber.reg.test(this.formData.couponCode)) {
        this.$wejs.alert(regs.cardNumber.msg)
        return false
      }
      this.cardInfo = await this.bindItem.getCardInfo()
      if (this.disabledIndustry) {
        this.formData.industryId.value = this.userVersionObj.targetIndustryVersion
      }
      if (!this.cardInfo.isCommonIndustryCoupon) {
        this.formData.industryId.value = 0
      }
      if (this.cardInfo.isValid) {
        this.gotCardInfo = false
        return
      }
      return this.$wejs.alert(this.cardInfo.message)
    },
    // 清除表单，还原
    clearForm () {
      this.formData.couponCode = ''
      this.formData.industryId = { label: '', value: null } // 清空行业选择
    },
    // 激活实体卡
    async activeCard () {
      await this.bindItem.activateCard(this.cardInfo.id)
      this.goToResult(this.cardInfo.name)
    },
    goToResult () {
      this.$router.push({ path: `/card-bind/result`, query: { name: this.cardInfo.name } })
    },
    // 绑定实体卡
    bindSubmit: debounce(function () {
      if (!this.cardInfo.isValid) {
        this.$wejs.alert(this.cardInfo.message)
        return
      }
      if (this.bindCardValidate()) {
        // 选中当前用户行业版本
        if (this.userVersionObj.targetIndustryVersion > 0) {
          this.formData.industryId.value = this.userVersionObj.targetIndustryVersion
        }
        // 判断优惠券是否已绑定
        if (this.cardInfo.couponStatus === this.couponStatus.couponHasBind) {
          this.bindCoupon()
        } else if (this.cardInfo.couponStatus === this.couponStatus.couponActive) {
          this.activeCard()
        } else {
          this.$wejs.alert('此优惠券已激活,不能重复使用！')
        }
      }
    }, 300),
    // 输入状态显示‘确定’
    inputChange () {
      this.gotCardInfo = true
    }
  },
  computed: {
    // 是否禁用选择框
    disabledIndustry () {
      return this.cardInfo.isCommonIndustryCoupon && this.userVersionObj.targetIndustryVersion > 0 && this.userVersionObj.canOnlyBindIndustryVersion
    },
    // 显示行业列表
    showIndustry () {
      return this.cardInfo.isCommonIndustryCoupon && !this.showConfirmBtn
    },
    // 显示输入框‘确认’
    showConfirmBtn () {
      let couponCodeLengthValid = this.formData.couponCode.length === 14
      return couponCodeLengthValid && this.gotCardInfo
    }
  },
  watch: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?526f7a59